export const life = {};
export const event = {
  clickUserName(){
    this.$emit('clickUserName');
  },
  // 点击退出
  async logout() {
    const confirm = await this.$confirm('确定登出系统？', '登出确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    });
    if (confirm === 'confirm') {
      this.methods('logout')
    }
  }
};
